<div class="certification-table" *ngIf="isTranslationLoaded">
    <h3>{{ 'reportingV2.CERTIFICATION_ASSIGNMENT_LABEL' | transloco }}</h3>

    <div class="table-wrapper">
        <div *ngIf="isLoading" class="loading-container">
            <qai-loading [size]="'medium'"></qai-loading>
        </div>

        <div>
            <qai-table *ngIf="!isLoading && tableData.length > 0" [headers]="headers" [data]="tableData"
                [currentPage]="currentPage"
                [initialSortColumn]="initialSortColumn" [initialSortDirection]="initialSortDirection"
                (sortChanged)="onSortChanged($event)" (pageChanged)="onPageChanged($event)" (rowClick)="onTableRowClick($event)"
                (cellClick)="onCellClick($event)"
                [previousLabel]="'reportingV2.PAGINATION_PREVIOUS' | transloco" [nextLabel]="'reportingV2.PAGINATION_NEXT' | transloco"></qai-table>
        </div>
    </div>
</div>